<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<p class="dedit">To Chris Shores in admiration of his brilliant researches and appreciation of his kind assistance to me.</p>
<a id="page_vi"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?1a6f73c5